module.exports = __webpack_public_path__ + "static/img/m1_t2_edge.4b5f7c08.jpg";